import 'antd/dist/antd.min.css';
import React, { useEffect, useState } from 'react';
import { Route, Routes, useNavigate, Navigate } from "react-router-dom";
import { Avatar, Breadcrumb, Drawer, Layout, Menu } from 'antd';
import {
    TeamOutlined,
    MailOutlined,
    ProfileOutlined,
    AppstoreOutlined,
    MedicineBoxOutlined,
    BarsOutlined,
    CloseOutlined,
    UserOutlined,
    CalendarOutlined,
    DollarOutlined,
    CoffeeOutlined,
    HomeOutlined,
    UsergroupAddOutlined
} from '@ant-design/icons';
import { Login } from "../pages/Auth/Login";
import { Registration } from "../pages/Auth/Registration";
import { NutritionistDashboard } from "../pages/Admin/Dashboard/NutritionistDashboard";
import { PlanPricing } from "../pages/Admin/Plans/PlansPricing";
import { ForgetPassword } from "../pages/Auth/ForgetPassword";
import { ResetPassword } from "../pages/Auth/ResetPassword";
import { VerifyEmail } from "../pages/Auth/VerifyEmail";
import { VerifyEmailNotice } from "../pages/Auth/VerifyEmailNotice";
import { isStoredUserVerified } from "../services/EmailVerified";
import { hasStoredActivePlan } from "../services/Plan";
import { ChoosePlan } from "../pages/Billing/ChoosePlan";
import { MyPlan } from "../pages/Billing/MyPlan";
import { AdminPayments } from "../pages/Billing/AdminPayments";
import { PlanExpiryBanner } from "../pages/Billing/PlanExpiryBanner";
import companyLogo from '../assets/8well-logo.svg'
import { ProfileSection } from '../pages/ProfileSection';
import { useLocation } from 'react-router-dom';
import { UsersList } from '../pages/Admin/Users/UsersList';
import { AddUser } from '../pages/Admin/Users/AddUser';
import { Recipe } from '../pages/Admin/MasterMenu/Recipe/Recipe';
import { Patient } from '../pages/Admin/MasterMenu/Patient/Patient';
import { ClientsList } from '../pages/Admin/ClientsList/ClientsList';
import { PatientDetail } from '../pages/Admin/ClientsList/ClientDetail/ClientDetail';
import { ProgramsList } from '../pages/Admin/ProgramList/ProgramList';
import { Appointments } from '../pages/Appointments/Appointments';
import { Complaints } from '../pages/Admin/Complaints/Complaints';
import { EmailTemplate } from '../pages/Admin/EmailTemplate/EmailTemplate';
import { CreateEmailTemplate } from '../pages/Admin/EmailTemplate/components/CreateEmailTemplate';
import { NutrionistEmailTemplate } from '../pages/Admin/EmailTemplate/NutrionistEmailTemplate';
import { ManageRecipe } from '../pages/Admin/ManageRecipe/ManageRecipe';
import { AddOrEditRecipe } from '../pages/Admin/ManageRecipe/components/AddOrEditRecipe';
import { Ingredients } from '../pages/Admin/Ingredients/Ingredients';
import { AddIngredient } from '../pages/Admin/Ingredients/components/AddIngredient';
import { AddIngredientLateast } from '../pages/Admin/Ingredients/components/AddIngredientLateast';
import { createCookie, readAuthCookie, readCookie } from '../config/CookieScript';
import { AddHerbsDetails } from '../pages/Admin/MasterMenu/Patient/components/AddHerbsDetails';
import { UserProfile } from '../pages/UserProfile/UserProfile';
import { NotFoundPage } from '../pages/NotFoundPage/NotFoundPage';
import { ADMIN_ROLE, ROLE_KEYWORD } from '../config/constant';
import { MeasurementsMaster } from '../pages/Admin/ClientsList/ClientDetail/MeasurementsMaster';
import { HerbsManagement } from '../pages/Admin/MasterMenu/Patient/components/HerbsManagement';
import { FocusHealthAreas } from '../pages/Admin/MasterMenu/Patient/components/FocusHealthAreas';
import { HomePage } from '../pages/HomePage/HomePage';
// to use summer note editor jquery required     
window.jQuery = require("jquery");

const { Header, Content, Footer, Sider } = Layout;

function getItem(label, key, icon, children) {
    return {
        key,
        icon,
        children,
        label,
    };
}

export const ProjectRoutes = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const [collapsed, setCollapsed] = useState(false);
    const [isProfileDrawerVisible, setIsProfileDrawerVisible] = useState(false);

    const [isUserHasMeasurementRight, setIsUserHasMeasurementRight] = useState(false);
    const [isUserHasHerbManageRight, setIsUserHasHerbManageRight] = useState(false);

    // side bar menu names,its routes and icon list data
    //==============================
    const Adminitems = [
        readCookie(ROLE_KEYWORD) !== ADMIN_ROLE && getItem('Home', '/Home', <HomeOutlined />),
        readCookie(ROLE_KEYWORD) !== ADMIN_ROLE && getItem('Dashboard', '/Dashboard', <AppstoreOutlined />),
        readCookie(ROLE_KEYWORD) == ADMIN_ROLE && getItem('Users', '/users-list', <MedicineBoxOutlined />),
        // getItem('User', 'sub1', <UserOutlined />, [
        //   getItem('Tom', '3'),
        //   getItem('Bill', '4'),
        //   getItem('Alex', '5'),
        // ]),
        // exist code
        // readCookie(ROLE_KEYWORD) !== ADMIN_ROLE && getItem('Program List', '/programs-list', <BarsOutlined />),
        // change code
        getItem('Program List', '/programs-list', <BarsOutlined />),
        //  getItem('Program List', '/programs-list', <BarsOutlined />),
        // getItem('Email Template', '/email-template', <MailOutlined />),
        // getItem('Email Template', '/nutrionist-email-template', <MailOutlined />),
        getItem('Complaints', '/complaints', <AppstoreOutlined />),
        // getItem('Manage Recipes', '12', <ProfileOutlined />),
        getItem('Appointments', 'appointments', <CalendarOutlined />),
        readCookie(ROLE_KEYWORD) !== ADMIN_ROLE && getItem('Client List', '/client-list', <UsergroupAddOutlined />),
        readCookie(ROLE_KEYWORD) == ADMIN_ROLE && getItem('Plan Pricing', '/plans-pricing', <DollarOutlined />),
        readCookie(ROLE_KEYWORD) == ADMIN_ROLE && getItem('Payments', '/payments', <DollarOutlined />),
        readCookie(ROLE_KEYWORD) !== ADMIN_ROLE && getItem('My Plan', '/my-plan', <DollarOutlined />),
        readCookie(ROLE_KEYWORD) == ADMIN_ROLE && getItem('Master Menu', '/master-menu', <TeamOutlined />, [getItem('Recipe', 'master/recipe'), getItem('Patient', 'master/patient')]),
        getItem('Manage Recipes', '/manage-recipe', <CoffeeOutlined />),
        readCookie(ROLE_KEYWORD) !== ADMIN_ROLE && getItem('Focus Health Area', '/focus-health-area', <ProfileOutlined />),
        readCookie(ROLE_KEYWORD) == ADMIN_ROLE && getItem('Ingredients', '/ingredients', <ProfileOutlined />),
        // isUserHasMeasurementRight && getItem('Measurement', '/measurement', <TeamOutlined />),
        // isUserHasHerbManageRight || readCookie(ROLE_KEYWORD) !== ADMIN_ROLE && getItem('Herb Management', '/herb-management', <TeamOutlined />),
        isUserHasHerbManageRight && getItem('Herb Management', '/herb-management', <TeamOutlined />),
    ];

    // set header name code
    // useEffect(() => {
    //     // root path has dashboard page 
    //     if (location.pathname == '/') {
    //         return setHeaderName("Dashboard");
    //     }
    //     // if (location.pathname == '/add-user') {
    //     //     return setHeaderName("Add User");
    //     // }
    //     // get the menu label from array by comparing active location pathname and array items path 
    //     const HeaderTitle = Adminitems.find((element) => element.key == location.pathname)
    //     if (HeaderTitle) {
    //         setHeaderName(HeaderTitle.label);
    //     } else {
    //         setHeaderName(location.pathname);
    //     }
    // }, [location.pathname]);
    useEffect(() => {
        let headerName = localStorage.getItem('title')
        // console.log(headerName)
        setHeaderName(headerName)

        if (location.pathname == '/focus-health-area') {
            setHeaderName("Focus Health Area")
        }
        if (location.pathname == '/Dashboard') {
            setHeaderName("Dashboard")
        }
        // }, [location.pathname]);
        // }, []);
    });
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [isEmailVerified, setIsEmailVerified] = useState(isStoredUserVerified());
    const [headerName, setHeaderName] = useState('');

    const [open, setOpen] = useState(false);

    const showDrawer = () => {
        setOpen(true);
    };

    const onClose = () => {
        setOpen(false);
    };

    useEffect(() => {

        if (readAuthCookie('auth_token')) {
            // if nutrionist has measurement right then visible as new menu else hide    
            let isMeasurementRight = JSON.parse(localStorage.getItem('user'))
            setIsUserHasMeasurementRight(isMeasurementRight?.user?.measurements_management_right)
            setIsUserHasHerbManageRight(isMeasurementRight?.user?.herbs_management_right)
            setIsEmailVerified(isStoredUserVerified())
            setIsAuthenticated(true)
        } else {
            setIsAuthenticated(false)
        }
    })

    // if user is login redirect to dashboard
    useEffect(() => {

        // console.log(readCookie('auth_token'));
        let isTokenExist = readAuthCookie('auth_token');
        if (isTokenExist) {
            setIsAuthenticated(true)
            // console.log('if', isAuthenticated);
        } else {
            setIsAuthenticated(false)
            // console.log('else', isAuthenticated);
            if (location.pathname !== '/' && location.pathname !== '/register' && location.pathname !== '/forget-password' && location.pathname !== '/reset-password' && location.pathname !== '/verify-email') {
                navigate('/')
            }
        }
    }, [isAuthenticated, location.pathname]);



    // redirect on given path while click on menu
    //==============================
    const onClick = (e) => {
        navigate(e.key)
    };

    // the link from the verification email works whether or not someone is logged in
    if (location.pathname === '/verify-email') {
        return <VerifyEmail />
    }

    // the login cookie is checked directly: right after logout the isAuthenticated state is still true
    // for one render, and these screens would call the API without a login (401)
    const hasLogin = isAuthenticated && Boolean(readAuthCookie('auth_token'))

    // logged in but email not verified yet: nothing else in the app is available
    if (hasLogin && !isEmailVerified) {
        return <VerifyEmailNotice />
    }

    // a doctor without an active plan (none chosen, or expired) can only choose one; admins don't need one
    if (hasLogin && readCookie(ROLE_KEYWORD) !== ADMIN_ROLE && !hasStoredActivePlan()) {
        return <ChoosePlan />
    }

    return (
        <>
            {isAuthenticated ?
                <Layout
                    style={{
                        minHeight: '100vh',
                    }}
                >
                    <Sider collapsible collapsed={collapsed} onCollapse={(value) => setCollapsed(value)}>
                        <div className="logo text-center">
                            {/* <img src={companyLogo} alt="logo" className="mt-3 p-2" style={{ width: collapsed ? "100%" : "80%" }} /> */}
                            <h3 className='text-white '>
                                Nutri Nexus
                            </h3>
                        </div>
                        <Menu theme="dark" defaultSelectedKeys={['1']} mode="vertical" items={Adminitems} className="mt-3" onClick={(e) => { onClick(e) }} />
                    </Sider>
                    <Layout className="site-layout">
                        <Header
                            className="site-layout-background"
                            // title={headerName}
                            style={{
                                padding: 0,
                                borderBottom: "1px solid #c0c0c0"
                            }}
                        >
                            <div className='header d-flex justify-content-between'>
                                <h3 className='w-50 ps-4 pt-3'>{headerName}</h3>
                                <Avatar shape="square" className='profileSection rounded' size="large" onClick={() => showDrawer()} icon={<UserOutlined />} />
                            </div>
                            <Drawer
                                onClose={onClose} open={open}
                                closable={false}
                                className="profileDrawer"
                            // width={window.innerWidth > 550 ? '20%' : '100%'}
                            // width={window.innerWidth >= 300 ? '20%' : '100%'}
                            >
                                <ProfileSection setOpen={setOpen} />
                            </Drawer>
                            {/* </div> */}
                        </Header>
                        <Content
                            style={{
                                margin: '0 16px',
                            }}
                        >
                            <div
                                className="site-layout-background"
                                style={{
                                    margin: '16px 0',
                                    padding: 24,
                                    minHeight: 360,
                                }}
                            >
                                {readCookie(ROLE_KEYWORD) !== ADMIN_ROLE && <PlanExpiryBanner />}
                                <Routes>
                                    {/* <Route path="/" element={<Login />} /> */}
                                    <>
                                        {/* redirect to not found page while enter unknown url */}
                                        <Route path="*" element={<NotFoundPage />} />
                                        <Route path="/" element={<NutritionistDashboard />} />
                                        <Route path="/Home" element={<HomePage />} />
                                        <Route path="/user-profile" element={<UserProfile />} />
                                        <Route path="/Dashboard" element={<NutritionistDashboard />} />
                                        <Route path="/plans-pricing" element={<PlanPricing />} />
                                        <Route path="/my-plan" element={<MyPlan />} />
                                        <Route path="/payments" element={<AdminPayments />} />
                                        <Route path="/nutrionist-email-template" element={<NutrionistEmailTemplate />} />
                                        {/* <Route path="/email-template" element={<EmailTemplate />} /> */}
                                        <Route path="/create-email-template" element={<CreateEmailTemplate />} />
                                        <Route path="/edit-email-template/:id" element={<CreateEmailTemplate />} />
                                        <Route path="/users-list" element={<UsersList />} />
                                        <Route path="/add-user" element={<AddUser />} />
                                        <Route path="/edit-user/:id" element={<AddUser />} />
                                        <Route path="/complaints" element={<Complaints />} />
                                        <Route path="/client-list" element={<ClientsList />} />
                                        <Route path="/programs-list" element={<ProgramsList />} />
                                        <Route path="/appointments" element={<Appointments />} />
                                        <Route path="/manage-recipe" element={<ManageRecipe />} />
                                        <Route path="/add-recipe" element={<AddOrEditRecipe />} />
                                        <Route path="/edit-recipe/:id" element={<AddOrEditRecipe />} />
                                        <Route path="/ingredients" element={<Ingredients />} />
                                        <Route path="/add-ingredient" element={<AddIngredientLateast />} />
                                        <Route path="/focus-health-area" element={
                                            <div className='m-3'>
                                                <FocusHealthAreas />
                                            </div>
                                        } />
                                        <Route path="/edit-ingredient/:id" element={<AddIngredientLateast />} />
                                        {/* ======================== */}
                                        {/* Patient pages routes  */}
                                        {/* ======================== */}
                                        <Route path="/patient-detail/:id" element={<PatientDetail />} />
                                        {/* ======================== */}
                                        {/* Patient Detail pages routes  */}
                                        {/* ======================== */}

                                        <Route path="/master/recipe" element={<Recipe />} />
                                        <Route path="/master/patient" element={<Patient />} />
                                        <Route path="/measurement" element={<MeasurementsMaster />} />
                                        <Route path="/herb-management" element={<HerbsManagement />} />
                                    </>
                                </Routes>
                            </div>
                        </Content>
                        <Footer className='text-center'>
                            Nutri Nexus ©2024 Created by Mansi Bhojani
                        </Footer>
                    </Layout>
                </Layout>
                :
                <Routes>
                    <Route path="*" element={<Login />} />
                    <Route path="/" element={<Login />} />
                    <Route path="/register" element={<Registration />} />
                    <Route path="/forget-password" element={<ForgetPassword />} />
                    <Route path="/reset-password" element={<ResetPassword />} />
                </Routes>
            }
        </>
    );
};
